import { formatDate } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { InternationalizationService } from '@services/utils/internationalization/internationalization.service';

@Pipe({ name: 'userDate' })
export class UserDatePipe implements PipeTransform {
    private readonly internationalizationService = inject(InternationalizationService);

    transform(value?: string | number | Date | null, timezone?: string): string {
        if (!value) {
            return '';
        }

        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) {
            return '';
        }

        return formatDate(date, this.internationalizationService.getDateFormat(), this.internationalizationService.getParsedLanguage(), timezone);
    }
}
